import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import { showNotification } from "react-admin";

import { pauseKiosk } from "../lib/serverCommands";

const showStyle = {
  button: {
    margin: "5px",
  },
};

class DisconnectButton extends Component {
  handleClick = () => {
    const { showNotification: shn, kiosk } = this.props;
    // psh("/kiosks");
    pauseKiosk({ ...kiosk })
      .then(() => shn("notification.endOfSell"))
      .catch(err => {
        shn("notification.errorSending"); // TODO: message
        console.error("Error sending start kiosk message", err);
      });
  };

  render() {
    const { translate } = this.context;
    const { kiosk } = this.props;
    return (
      <Button
        style={showStyle.button}
        color="primary"
        variant="contained"
        disabled={kiosk.status !== 0}
        onClick={this.handleClick}
      >
        {translate("button.disconnect")}
      </Button>
    );
  }
}

DisconnectButton.propTypes = {
  showNotification: PropTypes.func,
};
DisconnectButton.contextTypes = {
  translate: PropTypes.func,
};

export default connect(
  null,
  {
    showNotification,
  }
)(DisconnectButton);



// WEBPACK FOOTER //
// ./src/components/disconnectButton.js